import { useState, useEffect } from "react";
import { getNotificaciones, marcarLeida, marcarTodasLeidas, syncNotificacionesDesdeSupabase } from "./NotificadorALQOS";

// modulo: string o array de strings — filtra notifs del módulo activo
// si no se pasa modulo, muestra todas (modo legacy)
const MODULO_A_RUTA = {
  NC: "nc",
  OT: "ot",
  AccionesCorrectivas: "accionescorrectivas",
  TPM: "tpm",
  Usuarios: "adminusuarios",
  IngresoMateriales: "ingresomateriales",
  Stock: "stock",
  PrePrensa: "preprensa",
  Produccion: "produccion",
  Ventas: "ventas",
  Clientes: "clientes",
  AlqosNews: "alqosNews",
};
export default function CampanaNotificaciones({ oscuro, modulo }) {
  const [abierta, setAbierta] = useState(false);
  const [notifs, setNotifs] = useState([]);

  useEffect(() => {
    const cargar = () => {
      const todas = getNotificaciones();
      if (!modulo) { setNotifs(todas); return; }
      const modulos = Array.isArray(modulo) ? modulo : [modulo];
      setNotifs(todas.filter(n => modulos.includes(n.modulo)));
    };
    cargar();
    syncNotificacionesDesdeSupabase();
    const iv = setInterval(() => { syncNotificacionesDesdeSupabase(); }, 30000);
    window.addEventListener("alqos-notif-nueva", cargar);
    return () => { clearInterval(iv); window.removeEventListener("alqos-notif-nueva", cargar); };
  }, [modulo]);

  const noLeidas = notifs.filter(n => !n.leida).length;
  const cardBg  = oscuro ? "#0d2160" : "white";
  const texto   = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde   = oscuro ? "#1e3a8a" : "#eee";
  const sub     = oscuro ? "#9aabd4" : "#808085";

  const handleLeida  = (id) => { marcarLeida(id);      setNotifs(n => n.map(x => x.id===id ? {...x,leida:true} : x)); };
  const handleClickNotif = (n) => {
    handleLeida(n.id);
    const ruta = MODULO_A_RUTA[n.modulo];
    if (ruta) {
      window.dispatchEvent(new CustomEvent("alqos-navegar", { detail: { modulo: ruta } }));
      setAbierta(false);
    }
  };
  const handleTodas  = ()   => { marcarTodasLeidas();  setNotifs(n => n.map(x => ({...x,leida:true}))); };

  return (
    <div style={{ position:"relative" }}>
      <button onClick={() => setAbierta(a => !a)}
        style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 10px", borderRadius:"10px", cursor:"pointer", fontSize:"18px", position:"relative" }}>
        🔔
        {noLeidas > 0 && (
          <span style={{ position:"absolute", top:"-2px", right:"-2px", background:"#e63946", color:"white", fontSize:"9px", fontWeight:"700", width:"16px", height:"16px", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center" }}>
            {noLeidas > 9 ? "9+" : noLeidas}
          </span>
        )}
      </button>

      {abierta && (
        <div style={{ position:"absolute", right:0, top:"calc(100% + 8px)", width:"320px", background:cardBg, borderRadius:"16px", border:`1px solid ${borde}`, boxShadow:"0 8px 32px rgba(9,24,77,0.2)", zIndex:200, overflow:"hidden" }}>
          <div style={{ padding:"12px 16px", borderBottom:`1px solid ${borde}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ fontSize:"13px", fontWeight:"700", color:texto }}>
              🔔 {modulo ? `Alertas — ${Array.isArray(modulo)?modulo.join(", "):modulo}` : "Notificaciones"}
              {noLeidas > 0 && <span style={{ color:"#e63946", marginLeft:"6px" }}>({noLeidas} nuevas)</span>}
            </span>
            {noLeidas > 0 && <button onClick={handleTodas} style={{ background:"none", border:"none", fontSize:"11px", color:"#7B5BF2", cursor:"pointer", fontWeight:"600" }}>Marcar todas</button>}
          </div>
          <div style={{ maxHeight:"360px", overflowY:"auto" }}>
            {notifs.length === 0
              ? <div style={{ padding:"2rem", textAlign:"center", color:sub, fontSize:"13px" }}>Sin alertas para este módulo</div>
              : notifs.slice(0,20).map(n => (
                <div key={n.id} onClick={() => handleClickNotif(n)}
                  style={{ padding:"12px 16px", borderBottom:`1px solid ${borde}`, background:n.leida?"transparent":`${n.color||"#7B5BF2"}08`, cursor:"pointer" }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"8px" }}>
                    <div style={{ flex:1 }}>
                      <p style={{ fontSize:"12px", fontWeight:n.leida?"500":"700", color:n.leida?sub:texto, margin:"0 0 3px" }}>{n.titulo}</p>
                      <p style={{ fontSize:"11px", color:sub, margin:"0 0 3px", lineHeight:"1.4" }}>{n.mensaje}</p>
                      <p style={{ fontSize:"10px", color:sub, margin:0 }}>{new Date(n.fecha).toLocaleString("es-AR")}</p>
                    </div>
                    {!n.leida && <div style={{ width:"8px", height:"8px", borderRadius:"50%", background:n.color||"#7B5BF2", flexShrink:0, marginTop:"4px" }}/>}
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
}
